export default __webpack_public_path__ + "static/media/nibbleSlide1.c24f34d5.png";